import {Component, OnInit, ViewChild} from '@angular/core';
import { MatSort} from '@angular/material/sort';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {PendingDoc} from '../models/pending-doc';
import {DocumentDialogComponent} from './dialogs/document-dialog/document-dialog.component';
import {PendingDocService} from '../services/pending-doc.service';
import {MatPaginator} from '@angular/material/paginator';
import {Subscription} from 'rxjs';

import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import {UploadDocumentDialogComponent} from './dialogs/upload-document-dialog/upload-document-dialog.component';
import {FormGroup} from '@angular/forms';
import {Folder} from '../models/folder';
import {FolderService} from '../services/folder.service';
import {DocumentFolderDialogComponent} from './dialogs/document-folder-dialog/document-folder-dialog.component';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {AlertComponent} from '../shared/dialogs/alert/alert.component';
import {DocumentService} from '../services/document.service';
import {DocumentMoveDialogComponent} from './dialogs/document-move-dialog/document-move-dialog.component';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: [ './document.component.scss' ],
  entryComponents: [
    DocumentDialogComponent
  ]
})
export class DocumentComponent implements OnInit {

  private sub: Subscription;
  private subApproved: Subscription;

  public pendingDataSource: MatTableDataSource<any>
  public sentDataSource: MatTableDataSource<any>
  public approvedDataSource: MatTableDataSource<any>

  public displayedPendingColumns: string[] = [ 'icon', 'member_name', 'product_name', 'edit' ];
  public displayedSentColumns: string[] = [ 'icon', 'member_name', 'product_name', 'edit' ];
  public displayedApprovedColumns: string[] = [ 'icon', 'member_name', 'product_name', 'edit' ];

  public folders: any[] = []
  public allDocs: any[] = []

  constructor (
    private _pendingDocService: PendingDocService,
    private _documentService: DocumentService,
    public _folderService: FolderService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router,
  ) {

    if (!this._authService.isAdmin) {
      this.router.navigate([ 'home' ]);
    }

    this.loadFolders()

    // this.loadApprovedDocuments()
  }

  @ViewChild('paginatorPending', {read: MatPaginator, static: true}) paginatorPending: MatPaginator;
  @ViewChild('paginatorSent', {read: MatPaginator, static: true}) paginatorSent: MatPaginator;
  @ViewChild('paginatorApproved', {read: MatPaginator, static: true}) paginatorApproved: MatPaginator;

  @ViewChild('pendingSort', {read: MatSort, static: true}) pendingSort: MatSort;
  @ViewChild('sentSort', {read: MatSort, static: true}) sentSort: MatSort;
  @ViewChild('approvedSort', {read: MatSort, static: true}) approvedSort: MatSort;

  ngOnInit () {

  }

  ngOnDestroy () {
    if (this.sub)
      this.sub.unsubscribe();

    if (this.subApproved)
      this.subApproved.unsubscribe();
  }

  loadFolders () {

    this.sub = this._folderService.select()
      .subscribe((result) => {
        this.folders = []
        result.forEach((item) => {
          let entity = new Folder();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name
          this.folders.push(entity)
        })
        //console.log(JSON.stringify(this.folders))
        this.loadDocuments()
        this.loadAllDocs()
      })
  }

  loadDocuments () {

    this.sub = this._pendingDocService.select()
      .subscribe((result) => {

        let pendingArray: PendingDoc[] = [];
        let sentArray: PendingDoc[] = [];
        let approvedArray: PendingDoc[] = [];

        result.forEach((item) => {
          let entity = new PendingDoc();
          entity.id = item.payload.doc.id;
          entity.sent = item.payload.doc.data().sent ? true : false
          entity.pending = item.payload.doc.data().pending ? true : false
          entity.approved = item.payload.doc.data().approved ? true : false
          entity.member_name = item.payload.doc.data().member_name;
          entity.member_id = item.payload.doc.data().member_id;
          entity.product_name = item.payload.doc.data().product_name;
          entity.product_id = item.payload.doc.data().product_id;
          let dt: any = item.payload.doc.data().date;
          entity.date = new Date(dt.seconds * 1000)
          entity.obs = item.payload.doc.data().obs;

          if (entity.pending && !entity.sent && !entity.approved) { // 
            pendingArray.push(entity)
          }
          else if (!entity.pending && entity.sent && !entity.approved) {
            sentArray.push(entity)
            //       console.log(JSON.stringify(entity))
          }
          //else if (!entity.pending && !entity.sent && entity.approved) {
          else if (entity.approved) {
            approvedArray.push(entity)
          }

        })

        this.pendingDataSource = new MatTableDataSource(pendingArray);
        this.pendingDataSource.paginator = this.paginatorPending;
        this.pendingDataSource.sort = this.pendingSort;

        this.sentDataSource = new MatTableDataSource(sentArray);
        this.sentDataSource.paginator = this.paginatorSent;
        this.sentDataSource.sort = this.sentSort;

        this.approvedDataSource = new MatTableDataSource(approvedArray);
        this.approvedDataSource.paginator = this.paginatorApproved;
        this.approvedDataSource.sort = this.approvedSort;

      })

  }



  loadAllDocs () {

    this.sub = this._documentService.selectAllDocs()
      .subscribe((result) => {
        this.allDocs = []

        result.forEach((item) => {

          let entity: any = {}
          entity.id = item.payload.doc.id;
          entity.approved = item.payload.doc.data().approved
          entity.date = item.payload.doc.data().date
          entity.filename = item.payload.doc.data().filename

          entity.member_id = item.payload.doc.data().member_id
          entity.member_name = item.payload.doc.data().member_name
          entity.url = item.payload.doc.data().url
          entity.selected = false

          let f_id: any = null
          f_id = item.payload.doc.data().folder_id
          entity.folder_id = f_id ? f_id : 'sETMnBqEPJB6ky0paoF4' // folder default = *

          this.allDocs.push(entity)
        })

        this.populateFolders()
      })

  }

  populateFolders () {

    this.folders.forEach((item) => {
      item.files = []
      const files = this.allDocs.filter((e) => {
        return e.folder_id == item.id
      })
      item.files = files
    })

  }

  goToLink (url: string) {
    window.open(url, "_blank");
  }

  applyFilterPending (filterValue: string) {
    this.pendingDataSource.filter = filterValue.trim().toLowerCase();
    if (this.pendingDataSource.paginator) {
      this.pendingDataSource.paginator.firstPage();
    }
  }

  applyFilterSent (filterValue: string) {
    this.sentDataSource.filter = filterValue.trim().toLowerCase();
    if (this.sentDataSource.paginator) {
      this.sentDataSource.paginator.firstPage();
    }
  }

  applyFilterApproved (filterValue: string) {
    this.approvedDataSource.filter = filterValue.trim().toLowerCase();
    if (this.approvedDataSource.paginator) {
      this.approvedDataSource.paginator.firstPage();
    }
  }

  openDialog (entity) {

    let data: PendingDoc = new PendingDoc();

    if (entity) {
      data = entity;
    }

    this.dialog.open(DocumentDialogComponent, {
      width: '900px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: {'doc': data, 'folders': this.folders}
    });
  }

  openUploadDialog (entity) {

    let data: PendingDoc = new PendingDoc();

    if (entity) {
      data = entity;
    }

    this.dialog.open(UploadDocumentDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  openFolderDialog (entity) {

    let data: Folder = new Folder();

    if (entity) {
      data = entity;
    }

    let dialogRef = this.dialog.open(DocumentFolderDialogComponent, {
      width: '400px',
      height: '200px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const action: any = response[ 0 ];
        const formData: FormGroup = response[ 1 ];

        if (action === 'add') {
          this.insertFolder(formData.getRawValue())
        } else if (action === 'edit') {
          this.updateFolder(formData.getRawValue())
        }

      })

  }

  openFolderDeleteDialog (entity) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: entity.name + "<br><br>Excluir esta pasta?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._folderService.canDelete(entity.id)
          .subscribe((result) => {
            if (result.empty) {

              this.deleteFolder(entity.id)

            } else {
              this.dialog.open(AlertComponent, {
                width: '350px',
                height: '270px',
                panelClass: 'custom-dialog-container',
                data: {title: "Alerta", message: "Não pode apagar.<br><br>Esta pasta não está vazia!"}
              });
            }
          })

      }
    })

  }

  deleteFolder (id: any) {
    
    this._folderService.delete(id)
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("ERRO: " + err.message)
        this.snackBar.openSnackBar(err.message, '', 'error');
      })
      
  }

  insertFolder (data: any) {
    const entity = this.createEntity(data)

    this._folderService.insert(entity)
      .then((result) => {
        console.log(result.id)
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("ERRO: " + err.message)
        this.snackBar.openSnackBar(err.message, '', 'error');
      })

  }

  updateFolder (data: any) {
    const entity = this.createEntity(data)

    this._folderService.update(entity)
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("ERRO: " + err.message)
        this.snackBar.openSnackBar(err.message, '', 'error');
      })

  }

  createEntity (data): Folder {
    let entity = new Folder();
    entity.id = data.id;
    entity.name = data.name;
    return entity;
  }

  toggle_list (id) {
    const list = document.getElementById(id) as HTMLFormElement
    if (list.style.display === 'none') {
      list.style.display = 'block'
    } else {
      list.style.display = 'none'
    }
  }

  openMoveDialog () {

    let dialogRef = this.dialog.open(DocumentMoveDialogComponent, {
      width: '700px',
      height: '200px',
      panelClass: 'custom-dialog-container',
      data: this.folders
    });

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const folder: any = response[ 0 ];
        const folderTo_id: string = folder.id

        this.folders.forEach((folder) => {
          folder.files.forEach((file) => {

            if (file.selected) {
              const changeDoc = {
                'id': file.id,
                'folder_id': folderTo_id
              }
              console.log('changeDoc: ' + JSON.stringify(changeDoc))

              this._documentService.moveDocument(changeDoc)
                .then(() => {console.log('ok')})
                .catch((err) => {console.log(err.message)})
            }

          })

        })
        this.populateFolders()

      })

  }
}

